import { clientData as globalClientData } from "../controllers/GetClient";

export const getCurrencyRateMap = () => {
  try {
    const raw = localStorage.getItem("currencyrate");
    const parsed = raw ? JSON.parse(raw) : {};

    if (typeof parsed === "object" && parsed !== null) {
      return Object.entries(parsed).reduce((acc, [code, val]) => {
        if (Array.isArray(val)) acc[code] = val;
        return acc;
      }, {});
    }
  } catch (e) { }

  return { INR: [1, "₹"] };
};

export const getActiveCurrencyCode = (clientData) => {
  return clientData?.currency_format || globalClientData?.currency_format || "INR";
};

export const GetCurrencySymbol = (clientData) => {
  const code = getActiveCurrencyCode(clientData);
  const allRates = getCurrencyRateMap();
  return allRates[code]?.[1] || "₹";
};

export const convertClientCurrencyToINR = (price, clientData) => {
  if (price === undefined || price === null || price === "") return 0;
  if (Number(price) === 0) return 0;

  const currencyCode = getActiveCurrencyCode(clientData);
  const allRates = getCurrencyRateMap();
  const [rate = 1] = allRates[currencyCode] || [1];

  if (!rate || isNaN(rate)) return Number(price) || 0;

  const roundedRate = Number(rate);
  const convertedPrice = Number(price) / roundedRate;
  return Number(convertedPrice.toFixed(2));
};

export const ConvertCurrency = (amount, clientData) => {
  if (amount === undefined || amount === null || amount === "") return 0;
  if (Number(amount) === 0) return 0;

  const activeClient = clientData || globalClientData;
  const currencyCode = getActiveCurrencyCode(activeClient);
  const numberOfDecimals = activeClient?.number_of_decimals ?? 2;

  const allRates = getCurrencyRateMap();
  const [rate = 1] = allRates[currencyCode] || [1];
  const roundedRate = Number(rate);
  const converted = Number(amount) * roundedRate;
  const fixed = converted.toFixed(numberOfDecimals);
  return Number(fixed);
};
